import React from "react";
import PropTypes from "prop-types"; // Import PropTypes
import { Box, Paper } from "@mui/material";
import { IdentityCard } from "../components/common/IdentityCard";
import { ReportsPublished } from "../components/common/ReportCard";
import { StatsRow } from "../components/common/StatCard";

export const ProfileDetails = ({ data }) => {
    return (
        <Paper elevation={0} className=" px-3 bg-white rounded-xl">
            <Box className="flex gap-4">
                <Box>
                    <IdentityCard
                        profile_picture_url={
                            data.analystDetail.profile_picture_url
                        }
                        name={data.analystDetail.username}
                        phone={data.analystDetail.phone_number}
                        email={data.analystDetail.email}
                    />
                    <ReportsPublished
                        count={data?.analystDetail?.details?.total_publication}
                    />
                </Box>
                <Box>
                    <Box
                        className="flex flex-col gap-2 mt-1 rounded-lg"
                        sx={{ bgcolor: "#F6FAFF" }}
                    >
                        {/* First Row */}
                        <Box className="flex flex-row gap-2 flex-1">
                            {data.firstRow.map((stat, index) => (
                                <StatsRow
                                    key={index}
                                    {...stat}
                                    sx={{
                                        width: "10vw",
                                    }}
                                />
                            ))}
                        </Box>

                        {/* Divider between first and second row */}
                        <div className="border-t border-gray-300" />

                        {/* Second Row */}
                        <Box className="flex flex-row gap-2 flex-1">
                            {data.secondRow.map((stat, index) => (
                                <StatsRow
                                    key={index}
                                    {...stat}
                                    reverse={true}
                                    sx={{
                                        width: "10vw",
                                    }}
                                />
                            ))}
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Paper>
    );
};

// Add PropTypes for the ProfileDetails component
ProfileDetails.propTypes = {
    data: PropTypes.shape({
        firstRow: PropTypes.arrayOf(
            PropTypes.shape({
                rank: PropTypes.number.isRequired,
                total: PropTypes.number.isRequired,
                label: PropTypes.string.isRequired,
            })
        ).isRequired,
        secondRow: PropTypes.arrayOf(
            PropTypes.shape({
                rank: PropTypes.number.isRequired,
                total: PropTypes.number.isRequired,
                label: PropTypes.string.isRequired,
            })
        ).isRequired,
    }).isRequired,
};
